import React from 'react';
import { Explorer } from '../../explorer/components/Explorer';
import { DatabaseExplorerNode } from '../../explorer/models/DatabaseTreeModels';

interface DatabaseExplorerTreeProps {
  nodes: DatabaseExplorerNode[];
  selectedNodeId?: string;
  onNodeClick: (nodeId: string) => void;
  onToggleExpand: (nodeId: string) => void;
  onRefresh: (nodeId?: string) => void;
  searchTerm?: string;
  onSearchChange?: (term: string) => void;
  onAddConnection?: () => void;
  onCollapseAll?: () => void;
  onCollapseSidebar?: () => void;
  renderCustomActions?: () => React.ReactNode;
  className?: string;
  onContextMenuAction?: (nodeId: string, actionId: string) => void;
  highlightedConnectionIds?: Set<string>;
  highlightedNodeId?: string;
  onNodeHighlightComplete?: (connectionId: string) => void;
  onHighlightedNodeComplete?: () => void;
  onReconnect?: (connectionId: string) => Promise<boolean>;
  /**
   * T12 fix round 1, M-4 — a single `useCliDetection()` read from
   * `DatabaseExplorer.tsx`, threaded through `Explorer` → `TreeContext` so
   * every table/view row's "AI" submenu reads it instead of each row
   * subscribing itself.
   */
  aiCliAvailable?: boolean;
  aiCliDetectionLoading?: boolean;
}

export function DatabaseExplorerTree({
  nodes,
  selectedNodeId,
  onNodeClick,
  onToggleExpand,
  onRefresh,
  searchTerm,
  onSearchChange,
  onAddConnection,
  onCollapseAll,
  onCollapseSidebar,
  renderCustomActions,
  className,
  onContextMenuAction,
  highlightedConnectionIds,
  highlightedNodeId,
  onNodeHighlightComplete,
  onHighlightedNodeComplete,
  onReconnect,
  aiCliAvailable,
  aiCliDetectionLoading,
}: DatabaseExplorerTreeProps) {
  return (
    <Explorer
      nodes={nodes}
      onNodeClick={onNodeClick}
      onToggleExpand={onToggleExpand}
      onRefresh={onRefresh}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      onAdd={onAddConnection}
      onCollapseAll={onCollapseAll}
      onCollapseSidebar={onCollapseSidebar}
      renderCustomActions={renderCustomActions}
      className={className}
      selectedNodeId={selectedNodeId}
      onContextMenuAction={onContextMenuAction}
      highlightedConnectionIds={highlightedConnectionIds}
      highlightedNodeId={highlightedNodeId}
      onNodeHighlightComplete={onNodeHighlightComplete}
      onHighlightedNodeComplete={onHighlightedNodeComplete}
      onReconnect={onReconnect}
      aiCliAvailable={aiCliAvailable}
      aiCliDetectionLoading={aiCliDetectionLoading}
    />
  );
}
